import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SharedTableHeader } from "./SharedTableHeader";
import { SharedTableBody } from "./SharedTableBody";
export function SharedTable(props) {
    const { data, columnDefinitions, visibilityConfig, columnWidths, sortOption, onSortChange, stickyOffset = 0, className, headerClassName, bodyClassName, rowBodyClassName, additionalColumns = {}, // для дополнительных колонок, которых нет в itemsOrder
    alwaysVisibleColumnId = 6, // id колонки к которой добавляется ширина скрытых колонок
    BodyComponent = SharedTableBody } = props;
    const { itemsChecked, itemsOrder } = visibilityConfig;
    const allColumnDefinitions = {
        ...columnDefinitions,
        ...additionalColumns,
    };
    const visibleColumns = [
        ...itemsOrder.filter((id) => itemsChecked[id]),
        ...Object.keys(additionalColumns).map(Number),
    ];
    const hiddenColumns = [
        ...itemsOrder.filter((id) => !itemsChecked[id]),
        ...Object.keys(additionalColumns).map(Number),
    ];
    const adjustedColumnDefinitions = {
        ...allColumnDefinitions,
    };
    if (visibleColumns.includes(alwaysVisibleColumnId)) {
        const extraWidth = hiddenColumns.reduce((sum, colId) => sum + (columnWidths[colId] || 0), 0);
        const baseWidth = columnWidths[alwaysVisibleColumnId] || 0;
        adjustedColumnDefinitions[alwaysVisibleColumnId] = {
            ...adjustedColumnDefinitions[alwaysVisibleColumnId],
            width: `${baseWidth + extraWidth}px`,
        };
    }
    visibleColumns.forEach((colId) => {
        if (colId !== alwaysVisibleColumnId &&
            adjustedColumnDefinitions[colId] &&
            !adjustedColumnDefinitions[colId].width) {
            adjustedColumnDefinitions[colId] = {
                ...adjustedColumnDefinitions[colId],
                width: `${columnWidths[colId] || 0}px`,
            };
        }
    });
    const gridTemplateColumns = visibleColumns
        .map((colId) => adjustedColumnDefinitions[colId]?.width || "auto")
        .join(" ");
    return (_jsxs("div", { className: className, children: [_jsx(SharedTableHeader, { visibleColumns: visibleColumns, adjustedColumns: adjustedColumnDefinitions, sortOption: sortOption, onSortChange: onSortChange, stickyOffset: stickyOffset, headerClassName: headerClassName, gridTemplateColumns: gridTemplateColumns }), _jsx(BodyComponent, { data: data, visibleColumns: visibleColumns, adjustedColumns: adjustedColumnDefinitions, bodyClassName: bodyClassName, rowBodyClassName: rowBodyClassName, gridTemplateColumns: gridTemplateColumns })] }));
}
